function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { mergeConfigs, colorFactory } from '@shopify/polaris-tokens/dist-modern';
import { config } from '@shopify/polaris-tokens/dist-modern/configs/base';

function buildCustomPropertiesNoMemo(themeConfig, tokens) {
  var _themeConfig$colors = themeConfig.colors,
      colors = _themeConfig$colors === void 0 ? {} : _themeConfig$colors,
      colorScheme = themeConfig.colorScheme,
      config$1 = themeConfig.config,
      _themeConfig$frameOff = themeConfig.frameOffset,
      frameOffset = _themeConfig$frameOff === void 0 ? '0px' : _themeConfig$frameOff;
  var mergedConfig = mergeConfigs(config, config$1 || {});
  return customPropertyTransformer(_objectSpread2(_objectSpread2(_objectSpread2({}, colorFactory(colors, colorScheme, mergedConfig)), tokens), {}, {
    frameOffset: frameOffset
  }));
}

function buildThemeContext(themeConfig, cssCustomProperties) {
  var logo = themeConfig.logo,
      _themeConfig$colors2 = themeConfig.colors,
      colors = _themeConfig$colors2 === void 0 ? {} : _themeConfig$colors2,
      colorScheme = themeConfig.colorScheme;
  return {
    logo: logo,
    cssCustomProperties: toString(cssCustomProperties),
    colors: colors,
    colorScheme: colorScheme
  };
}

function toString(obj) {
  if (obj) {
    return Object.entries(obj).map(function (pair) {
      return pair.join(':');
    }).join(';');
  } else {
    return '';
  }
}

function customPropertyTransformer(properties) {
  return Object.entries(properties).reduce(function (transformed, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return _objectSpread2(_objectSpread2({}, transformed), {}, _defineProperty({}, toCssCustomPropertySyntax(key), value));
  }, {});
}

function toCssCustomPropertySyntax(camelCase) {
  return "--p-".concat(camelCase.replace(/([A-Z0-9])/g, '-$1').toLowerCase());
} // eslint-disable-next-line @typescript-eslint/ban-types


function memoize(fnToMemoize) {
  var cache = new Map();
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var key = JSON.stringify([fnToMemoize.name, args]);

    if (cache.get(key) === undefined) {
      cache.set(key, fnToMemoize.apply(void 0, args));
    }

    return cache.get(key);
  };
}

var buildCustomProperties = memoize(buildCustomPropertiesNoMemo);
export { buildCustomProperties, buildCustomPropertiesNoMemo, buildThemeContext, toCssCustomPropertySyntax, toString };